const React = require("react");

function PrinterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M17.9,19.5h3.5c0.4,0,0.6-0.3,0.6-0.6v-11H2 v11c0,0.4,0.3,0.6,0.6,0.6h3.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "17.9,7.8 17.9,2 6.2,2 6.2,7.8 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "17.9,14.5 17.9,22 6.2,22 6.2,14.5  "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.8,
    x2: 4.2,
    y1: 14.5,
    y2: 14.5,
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.7,
    x2: 8.3,
    y1: 17,
    y2: 17,
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.7,
    x2: 8.3,
    y1: 19.5,
    y2: 19.5,
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.8,
    x2: 17.4,
    y1: 11.2,
    y2: 11.2,
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }));
}

module.exports = PrinterIcon;